import type { VoiceTextType } from "utils";
import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";

export async function getVoiceTexts() {
  return axiosFetch.get("/api/voicetext");
}

export async function getVoiceTextById(id: string) {
  return axiosFetch.get(`/api/voicetext/${id}`);
}

export async function upsertVoiceText(body: VoiceTextType) {
  return axiosFetch.post("/api/voicetext", {
    ...body,
  });
}

export async function deleteVoiceText(id: string) {
  return axiosFetch.del(`/api/voicetext/${id}`);
}
